import { Chip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { User } from "@sentry/react";
import { createElement, useMemo } from "react";
import { TbBrandCake, TbHexagon, TbInfoCircle } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { softColors } from "@/constants/colors";
import { vehicleBrands } from "@/constants/vehicleBrands";
import { WeTrackVehicleData } from "@/types/wetrack.types";

function CarBrand({ brand }: { brand: string }) {
    const parsedBrand = useMemo(() => brand.toUpperCase() || "Araç Ataması yapılmadı", [brand]);
    const status = useMemo(
        () =>
            brand
                ? vehicleBrands.find((item) => item.values.includes(parsedBrand)) || {
                      ...softColors.brown,
                      values: [],
                      component: () => TbHexagon,
                  }
                : {
                      ...softColors.brown,
                      values: [],
                      component: () => TbInfoCircle,
                  },
        [parsedBrand]
    );
    return (
        <div className="flex items-center py-1 h-full">
            {
                <Chip
                    sx={{
                        backgroundColor: status.bg,
                        color: status.text,
                        fontWeight: 500,
                        fontSize: "12px !important",
                    }}
                    icon={createElement(status.component(), {
                        fontSize: 14,
                        color: status.text,
                    })}
                    label={parsedBrand}
                />
            }
        </div>
    );
}

export const BrandColumn = <T extends WeTrackVehicleData["properties"] | User>({
    getBrand,
}: {
    getBrand: (row: T) => string;
}): GridColDef<T> => {
    return {
        field: "vehicle_brand",
        headerName: "vehicleBrand",
        minWidth: 200,
        renderHeader: (params) => <TableHeader Component={TbBrandCake} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => getBrand(row as T),
        renderCell: ({ value }) => {
            return <CarBrand brand={value} />;
        },
    };
};
